import { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import { getServicios } from "../../services/public/servicios";
import { getVerficaDispensador, getdispensadorarea } from "../../services/public/dispensador";
import { getRegistrarTurno } from "../../services/public/turno";
import { getVerificarImpresora, getPingConnection } from "../../services/public/impresion";
import { print } from "./imprime";
import Toasts from "../toast";
import VincularModal from "./vincularmodal";
import BeneficiModal from "./beneficmodal";
import PrintModal from "./printmodal";
import CardServicios from "./cardservice";
import AreasDModal from "./areasmodals";
import Icon from "../../Icons/general/Icon";

function Dispenser() {
  const [Servicios, setServicios] = useState([]);
  const [Turno, setTurno] = useState([]);
  const [opciones, setOpciones] = useState([]);
  const [empresa, setEmpresa] = useState([]);
  const [areas, setAreas] = useState([]);
  const [isactive, setIsActive] = useState(false);

  const [AreaId, setArea] = useState(0);
  const [dispensaId, setDispensaId] = useState(0);
  const [servicioId, setServicioId] = useState(0); // servicio para el beneficiario
  const [areaBId, setAreaB] = useState(0); // area para beneficiario
  const [valida, setValida] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [showNoImprime, setShowNoImprime] = useState(false);
  const [connect, setConnect] = useState(false);
  const [conImpresora, setConImpresora] = useState(false);
  const [showM, setShowM] = useState(false);
  const [showMD, setShowMD] = useState(false);
  const [showDisp, setShowDisp] = useState(false);
  const [footerv, setFooter] = useState(false);

  const [impresora, setImpresora] = useState("No Definida");
  const [puerto, setPuerto] = useState("No Definido");
  const [dispensador, setDispensador] = useState("No Definido");
  const [equipo, setEquipo] = useState("No Definido");
  const [benefici, setBenefici] = useState("NO");
  const [prioritaria, setPrioritaria] = useState("NO");
  const [imprime, setImprime] = useState("");
  const [ruta, setRuta] = useState("");
  const [Lector, setLector] = useState("NO");
  const [Url, setUrl] = useState("NO");
  const [processingId, setProcessingId] = useState(null);
  const [tipodispensa, setTipodispensa] = useState("U");
  
  //--------------------------------------------------------------------------------------------------------------------
  const addParametros = async () => {
    let cookies = new Cookies();
    let Tipodisp='U';
    const Apk1 = cookies.get('ApkI');
    const Apk2 = cookies.get('ApkV');

    if (Apk1 && Apk2)
      {
         const DispensaId =  cookies.get('Ctrdisp');
         setDispensaId(Number(DispensaId)|| 0);
         const response = await getVerficaDispensador(DispensaId, Apk1, Apk2);
         if (response)
          {
            if (response.status === 200) 
              {
                cookies.set('ApkI',response.data.data[0].ClientAPKey, { path: "/",maxAge: 1000000 });
                cookies.set('ApkV',response.data.data[0].CodigoVinc, { path: "/",maxAge: 1000000 });
                cookies.set('Ctrdisp',response.data.data[0].DispensaId, { path: "/",maxAge: 1000000 });
                cookies.set('Ctrndisp',response.data.data[0].NombreDisp, { path: "/",maxAge: 1000000 });
                cookies.set('Simpr',response.data.data[0].Imprime, { path: "/",maxAge: 1000000 });
                cookies.set('Impr',response.data.data[0].Impresora, { path: "/",maxAge: 1000000 });
                cookies.set('Puerto',response.data.data[0].Puerto, { path: "/",maxAge: 1000000 });

                const Puerto = cookies.get('Puerto');
                const Impresora = cookies.get('Impr');
                const siImprime = cookies.get('Simpr')
            
                setLector(response.data.data[0].Lector);
                setUrl(response.data.data[0].UrlLector);
                setTipodispensa(response.data.data[0].TipoDispensa);
                Tipodisp = response.data.data[0].TipoDispensa;

                setDispensador(cookies.get('Ctrndisp'));
                setEquipo(cookies.get('ApkI'));
                setImprime(cookies.get('Simpr'));
               
                if (Impresora !=="")
                  setImpresora(Impresora);
                if (Puerto !=="")
                  setPuerto(Puerto);

                if (siImprime ==="SI") // si marco que imprima hace el proceso de buscar la impresora  
                  {
                     if ((Puerto ==="") || (Impresora ===""))  // sino hay estos datos bloquear los servicios
                       setIsActive(false);

                     if ((Puerto !=="") && (Impresora !=="")) // si los datos existen intenta conectar servicio y verificar la impresora
                       {
                         const connect = await getPingConnection();
                         if ((connect) && (connect.statusText ==="OK"))
                           {
                             setConnect(true);
                             const responseImpr = await getVerificarImpresora(Impresora);
                             if ((responseImpr) && (responseImpr.statusText === "OK"))
                               {
                                 setConImpresora(true);
                                 setIsActive(true);
                               } 
                             else  
                               setIsActive(false);
                            }
                         else setIsActive(false);
                        }
                   }    

                if (Tipodisp ==='M') 
                  setShowMD(true)
                else
                {
                  const response = await getdispensadorarea(DispensaId);
                  if (response)
                    {
                      if (response.status === 200) 
                        {
                            setArea(response.data.data[0].AreaId)
                            selectAreas(response.data.data[0].AreaId)
                        }
                      else
                        {
                          const Mensaje = response.message;
                          const opc = { type: "Danger", message: Mensaje, active: true };
                          setOpciones(opc);
                          setShowToast(true);
                        }
                    }
                }
                  
              }
            else
            {
              const Mensaje = response.message;
              const opc = { type: "Danger", message: Mensaje, active: true };
              setOpciones(opc);
              setShowToast(true);
              setValida(true);
            }
  
          }
      } 
     else
     {
      setValida(true);
     }
 };


//---------------------------------------------------------------------------------------------------------------------
const GenerarRutaArch = (Datos) => 
  {
    const NombreArch = Datos.ArchivoId + "_" + Datos.ItemId + "." + Datos.Formato;
    const RutaArch =  `${import.meta.env.BASE_URL}api/static/${Datos.RutaArch}/${NombreArch}`;
    setRuta(RutaArch);
  };

//----------------------------------------------------------------------------------------------------------------------  
 const togglePanel=()=> 
  {
     if (footerv)
        setFooter(false)
     else
        setFooter(true)
  }

//----------------------------------------------------------------------------------------------------------------------
const backToLeft=()=> 
  { setShowMD(true); 
    setShowDisp(false);
  }

//----------------------------------------------------------------------------------------------------------------------
const handleTurno = async (item) =>
  {
    setProcessingId(item.ServicioId);
    setShowToast(false);

    const area = item.AreaId;
    const servicio = item.ServicioId;
    const Prioridad = item.Prioritaria;
    
    if (benefici ==="SI") 
    {
      setAreaB(area);
      setServicioId(servicio);
      setPrioritaria(Prioridad);
      setShowM(true)
    }
    else 
    { 
      const Data={HistoriaId : null, TipoDoc: null, NumeroNit: null, NombreBen: null, Prioritaria: null};
      const response = await getRegistrarTurno(area, servicio, Data);
       if (response) 
        {
         if (response.status === 200) 
          {
             setTurno(response.data.data[0]);
             if (imprime==="SI")
               print(impresora, response.data.data[0]);
             else
               setShowNoImprime(true); // sino tiene marcado que imprima muestra en la ventana el turno
          } 
          else 
           {
              const Mensaje = response.message;
              const opc = { type: "Danger", message: Mensaje, active: true };
              setOpciones(opc);
              setShowToast(true);
           }
       }
    }
    setProcessingId(null); // desbloquear    
  };
 
  //--------------------------------------------------------------------------------------------------------------------
  const selectAreas = async(AreaId) => 
  {
    setShowToast(false);
    setShowMD(false);
    const response = await getServicios(AreaId);
    if (response) 
      {
        if (response.status === 200) 
          {
            setServicios(response.data.data);
            setEmpresa(response.data.empresa[0]);
            setAreas(response.data.area[0]);
            setBenefici(response.data.area[0].Benefic);
              await GenerarRutaArch(response.data.empresa[0]);
            setShowDisp(true);  
          } 
        else 
        {
          const Mensaje = response.message;
          const opc = { type: "Danger", message: Mensaje, active: true };
          setOpciones(opc);
          setShowToast(true);
        }
      }
  };
  
  //--------------------------------------------------------------------------------------------------------------------
  useEffect(() => 
    {
       addParametros();
    }, []);
   
  return (
    <>
    {showMD &&(
      <AreasDModal show={showMD} handleshow={setShowMD}  handleparams={selectAreas} dispensaId={dispensaId} setarea={setArea}></AreasDModal>
    )
    }
    {showDisp && ( 
          <div className="flex flex-col h-screen border rounded-lg shadow bg-disabled items-center justify-center bg-gradient-to-r from-disabled via-light to-disabled overflow-hidden">
             {/* Encabezado */}   
             <div className="flex flex-row w-full h-[7rem] mt-2 pb-3  shadow-lg shadow-border-stone-200 border-stone-200 space-x-3 font-semibold text-lg text-center items-center justify-center">
                 <div className=" flex items-center justify-center h-[3rem] min-w-[3rem]">
                    <img src={ruta} className="w-[4rem] h-[4rem] object-cover rounded-full"></img>
                 </div>
                 <div className="flex flex-col text-center items-center justify-center text-gray-400">
                     <div className="">{empresa.NombreTerc}</div>
                     <div className="">{areas.NombreArea}</div>
                 </div>
             </div>
             {/* Cuerpo */}   
            <div className="h-full w-[58%] flex flex-1 space-x-3 p-2 space-y-4 text-center items-center justify-center scroll-hidden">
                {AreaId > 0 && (
                   <div className="w-[70%] lg:w-[50%] mt-8 space-y-4" id="servicioview">
                      {Servicios.map((item) => {
                         return (
                           <div key={item.ServicioId}>
                               <CardServicios data={item} onClick={handleTurno} disabled={processingId === item.ServicioId }></CardServicios>
                           </div>
                         );
                      })}
                   </div>
                  ) 
                }
            </div>
            {/* Cuerpo */}   
            {footerv && ( 
                <div  id="bottom-panel" className="flex flex-row w-full h-[4.5rem]  border-t bg-gray-50 text-sm text-gray-600">
                     <div className="h-full flex flex-1 text-center justify-center items-center">
                         <ul className="flex flex-col space-y-1">
                            <li className="flex flex-row space-x-1">
                               <div className="w-[5.5rem] text-right">Dispensador :</div>
                               <div>{dispensador}</div>
                            </li>
                            <li className="flex flex-row space-x-1">
                               <div className="w-[5.5rem] text-right">Equipo :</div>
                                 <div>{equipo}</div>
                            </li>
                         </ul>
                     </div>

                    <div className="h-full flex flex-1 text-center justify-center items-center">
                        © Copyright 2023 Dkd Ingenierias - Derechos reservados.
                    </div>
      
                    <div className="h-full flex flex-1 text-center justify-center items-center">
                        <ul className="flex flex-col space-y-1">
                           <li className="flex flex-row space-x-1">
                              <i><Icon svg="print" className="w-4 h-4 fill-default opacity-80 hover:opacity-100" title="print" /></i>
                     <div className="w-[4.6rem] text-right">
                     Impresora :
                     </div> 
                      {conImpresora? (<Icon svg="checkCircle" className="w-4 h-4 fill-default opacity-80 hover:opacity-100" title="checkCircle" />) 
                       :(<Icon svg="errorCircle" className="w-4 h-4 fill-default opacity-80 hover:opacity-100" title="errorCircle" />)}
                     <div>
                         {impresora}
                     </div>
                   </li>  
                   <li className="flex flex-row space-x-1">
                       <i><Icon svg="globe" className="w-4 h-4 fill-default opacity-80 hover:opacity-100" title="globe" /></i>
                       <div className="w-[4.6rem] text-right">
                           Puerto :
                       </div>
                         { connect ? (<Icon svg="checkCircle" className="w-4 h-4 fill-default opacity-80 hover:opacity-100" title="checkCircle" />) 
                          :(<Icon svg="errorCircle" className="w-4 h-4 fill-default opacity-80 hover:opacity-100" title="errorCircle" />)}
                       <div>
                          {puerto}
                       </div>
                    </li>
                </ul>
              </div>
            </div>)}
            <div id="toggle-button"
                 onClick={togglePanel}
                    className="fixed w-9 h-9 bottom-6 right-6 rounded-full  flex justify-center items-center hover:border-default 
                                transition-transform  hover:scale-110 hover:cursor-pointer">
                       <Icon svg="chevronup" className={`w-7 h-7 fill-default opacity-80 hover:opacity-100 ${footerv ? 'rotate-180':'rotate-0'}`} title="errorCircle" />   
           </div>
         </div>)}
          
    {valida && (
      <VincularModal show={valida} handleshow={setValida} handleparams={addParametros}>
      </VincularModal>
      ) 
      }

     {tipodispensa ==='M' &&(
           <div className="fixed bottom-0 left-0 p-4">
              <button className="bg-gray-100 text-white rounded-full w-24 h-24 flex items-center justify-center" onClick={backToLeft}>
                  <Icon svg="back" className={`w-16 h-16 fill-default opacity-80 hover:opacity-100`} title="errorCircle" />   
             </button>
           </div>
          )
     } 

    {showM && (
            <BeneficiModal
              show={showM}
              handleshow={setShowM}
              AreaId={areaBId}
              ServicioId={servicioId}
              Prioritaria={prioritaria}
              Url={Url}
              Lector={Lector}
              handleimprime={setShowNoImprime}
              handleturno={setTurno}
            ></BeneficiModal>
          ) 
    }
      
    {showNoImprime && (
           <PrintModal
               show={showNoImprime}
               handleshow={setShowNoImprime}
               Turno={Turno}
            ></PrintModal>
      )
    }
    {showToast && (
          <Toasts
            type={opciones.type}
            message={opciones.message}
            active={opciones.active}
          ></Toasts>
        )}
</>
  )
}


export default Dispenser;
